
export const renderDate = [
  {
    renderKey: "Intel XEON",
    renderValue: [{
        Processor: "X5698 ",
        cores: "1857",
        GHz: "2.3"
    }, {
        Processor: "W-2195 ",
        cores: "2191",
        GHz: "2.5"
    }, {
        Processor: "W-2175 ",
        cores: "2320",
        GHz: "3.3"
    }, {
        Processor: "W-2155 ",
        cores: "2476",
        GHz: "3"
    }, {
        Processor: "W-2150B ",
        cores: "2479",
        GHz: "3.7"
    }, {
        Processor: "W-2145 ",
        cores: "2520",
        GHz: "3.2"
    }, {
        Processor: "W-2140B ",
        cores: "2353",
        GHz: "3.7"
    }, {
        Processor: "W-2135 ",
        cores: "2536",
        GHz: "3.6"
    }, {
        Processor: "W-2133 ",
        cores: "2178",
        GHz: "4"
    }, {
        Processor: "W-2125 ",
        cores: "2510",
        GHz: "3.6"
    }, {
        Processor: "W-2123 ",
        cores: "2153",
        GHz: "2.5"
    }, {
        Processor: "Silver 4215 ",
        cores: "1986",
        GHz: "3"
    }, {
        Processor: "Silver 4123 ",
        cores: "1856",
        GHz: "2.1"
    }, {
        Processor: "Platinum 8176 ",
        cores: "2047",
        GHz: "2"
    }, {
        Processor: "Platinum 8173M ",
        cores: "2003",
        GHz: "2.7"
    }, {
        Processor: "Platinum 8168 ",
        cores: "2073",
        GHz: "3.4"
    }, {
        Processor: "Platinum 8151 ",
        cores: "2258",
        GHz: "3"
    }, {
        Processor: "Platinum 8124M ",
        cores: "1966",
        GHz: "2.8"
    }, {
        Processor: "Gold 6242 ",
        cores: "2002",
        GHz: "2.1"
    }, {
        Processor: "Gold 6230 ",
        cores: "2224",
        GHz: "3"
    }, {
        Processor: "Gold 6154 ",
        cores: "2122",
        GHz: "2.1"
    }, {
        Processor: "Gold 6152 ",
        cores: "2033",
        GHz: "2.4"
    }, {
        Processor: "Gold 6148 ",
        cores: "1940",
        GHz: "3.2"
    }, {
        Processor: "Gold 6146 ",
        cores: "2331",
        GHz: "3.5"
    }, {
        Processor: "Gold 6144 ",
        cores: "2391",
        GHz: "2"
    }, {
        Processor: "Gold 6138 ",
        cores: "2103",
        GHz: "3"
    }, {
        Processor: "Gold 6136 ",
        cores: "2045",
        GHz: "3.2"
    }, {
        Processor: "Gold 6134 ",
        cores: "2125",
        GHz: "2.6"
    }, {
        Processor: "Gold 6132 ",
        cores: "2118",
        GHz: "3.4"
    }, {
        Processor: "Gold 6128 ",
        cores: "2114",
        GHz: "2.6"
    }, {
        Processor: "Gold 6126 ",
        cores: "1909",
        GHz: "3.6"
    }, {
        Processor: "Gold 5122 ",
        cores: "2034",
        GHz: "2.9"
    }, {
        Processor: "E5-4655 v3 ",
        cores: "1823",
        GHz: "2.6"
    }, {
        Processor: "E5-4627 v4 ",
        cores: "1865",
        GHz: "2.3"
    }, {
        Processor: "E5-2699 v3 ",
        cores: "1826",
        GHz: "2.3"
    }, {
        Processor: "E5-2698 v3 ",
        cores: "1846",
        GHz: "2.6"
    }, {
        Processor: "E5-2697A v4 ",
        cores: "1999",
        GHz: "2.6"
    }, {
        Processor: "E5-2697 v3 ",
        cores: "1993",
        GHz: "2.3"
    }, {
        Processor: "E5-2696 v3 ",
        cores: "1942",
        GHz: "2.3"
    }, {
        Processor: "E5-2695 v3 ",
        cores: "1884",
        GHz: "2.6"
    }, {
        Processor: "E5-2690 v4 ",
        cores: "1926",
        GHz: "2.6"
    }, {
        Processor: "E5-2690 v3 ",
        cores: "1980",
        GHz: "3"
    }, {
        Processor: "E5-2690 v2 ",
        cores: "1826",
        GHz: "3.1"
    }, {
        Processor: "E5-2689 v4 ",
        cores: "2168",
        GHz: "3"
    }, {
        Processor: "E5-2687W v4 ",
        cores: "1890",
        GHz: "3.1"
    }, {
        Processor: "E5-2687W v3 ",
        cores: "1945",
        GHz: "3.4"
    }, {
        Processor: "E5-2687W v2 ",
        cores: "2041",
        GHz: "3.1"
    }, {
        Processor: "E5-2687W ",
        cores: "1854",
        GHz: "2.5"
    }, {
        Processor: "E5-2680 v3 ",
        cores: "1873",
        GHz: "2.8"
    }, {
        Processor: "E5-2680 v2 ",
        cores: "1824",
        GHz: "2.5"
    }, {
        Processor: "E5-2679 v4 ",
        cores: "1854",
        GHz: "3.3"
    }, {
        Processor: "E5-2673 v2 ",
        cores: "2009",
        GHz: "3.2"
    }, {
        Processor: "E5-2667 v4 ",
        cores: "2002",
        GHz: "3.2"
    }, {
        Processor: "E5-2667 v3 ",
        cores: "2078",
        GHz: "3.3"
    }, {
        Processor: "E5-2667 v2 ",
        cores: "2018",
        GHz: "2.8"
    }, {
        Processor: "E5-2663 v3 ",
        cores: "1801",
        GHz: "2.6"
    }, {
        Processor: "E5-2660 v3 ",
        cores: "1842",
        GHz: "3.4"
    }, {
        Processor: "E5-2643 v4 ",
        cores: "2018",
        GHz: "3.4"
    }, {
        Processor: "E5-2643 v3 ",
        cores: "2021",
        GHz: "3.5"
    }, {
        Processor: "E5-2643 v2 ",
        cores: "1939",
        GHz: "2.4"
    }, {
        Processor: "E5-2640 v4 ",
        cores: "1854",
        GHz: "2.6"
    }, {
        Processor: "E5-2640 v3 ",
        cores: "1888",
        GHz: "3.5"
    }, {
        Processor: "E5-2637 v4 ",
        cores: "2038",
        GHz: "3.5"
    }, {
        Processor: "E5-2637 v3 ",
        cores: "2131",
        GHz: "3.5"
    }, {
        Processor: "E5-2637 v2 ",
        cores: "1848",
        GHz: "3"
    }, {
        Processor: "E5-2623 v3 ",
        cores: "1924",
        GHz: "2.3"
    }, {
        Processor: "E5-2618L v3 ",
        cores: "1932",
        GHz: "2.9"
    }, {
        Processor: "E5-1681 v3 ",
        cores: "2017",
        GHz: "3.4"
    }, {
        Processor: "E5-1680 v4 ",
        cores: "2200",
        GHz: "3.2"
    }, {
        Processor: "E5-1680 v3 ",
        cores: "2107",
        GHz: "3"
    }, {
        Processor: "E5-1680 v2 ",
        cores: "2076",
        GHz: "3.2"
    }, {
        Processor: "E5-1660 v4 ",
        cores: "2033",
        GHz: "3"
    }, {
        Processor: "E5-1660 v3 ",
        cores: "1827",
        GHz: "3.7"
    }, {
        Processor: "E5-1660 v2 ",
        cores: "2117",
        GHz: "3.3"
    }, {
        Processor: "E5-1660 ",
        cores: "1954",
        GHz: "3.6"
    }, {
        Processor: "E5-1650 v4 ",
        cores: "2177",
        GHz: "3.5"
    }, {
        Processor: "E5-1650 v3 ",
        cores: "2146",
        GHz: "3.5"
    }, {
        Processor: "E5-1650 v2 ",
        cores: "1997",
        GHz: "3.2"
    }, {
        Processor: "E5-1650 ",
        cores: "1910",
        GHz: "3.7"
    }, {
        Processor: "E5-1630 v4 ",
        cores: "2149",
        GHz: "3.7"
    }, {
        Processor: "E5-1630 v3 ",
        cores: "2179",
        GHz: "3.5"
    }, {
        Processor: "E5-1620 v4 ",
        cores: "2069",
        GHz: "3.5"
    }, {
        Processor: "E5-1620 v3 ",
        cores: "2038",
        GHz: "3.7"
    }, {
        Processor: "E5-1620 v2 ",
        cores: "1977",
        GHz: "3.6"
    }, {
        Processor: "E5-1620 ",
        cores: "1926",
        GHz: "3"
    }, {
        Processor: "E3-1585L v5 ",
        cores: "2011",
        GHz: "3.5"
    }, {
        Processor: "E3-1585 v5 ",
        cores: "2165",
        GHz: "3"
    }, {
        Processor: "E3-1575M v5 ",
        cores: "2113",
        GHz: "2.9"
    }, {
        Processor: "E3-1545M v5 ",
        cores: "2059",
        GHz: "3.1"
    }, {
        Processor: "E3-1535M v6 ",
        cores: "2284",
        GHz: "2.9"
    }, {
        Processor: "E3-1535M v5 ",
        cores: "1970",
        GHz: "2.8"
    }, {
        Processor: "E3-1515M v5 ",
        cores: "2043",
        GHz: "3"
    }, {
        Processor: "E3-1505M v6 ",
        cores: "2115",
        GHz: "2.8"
    }, {
        Processor: "E3-1505M v5 ",
        cores: "1911",
        GHz: "3.7"
    }, {
        Processor: "E3-1290 V2 ",
        cores: "2150",
        GHz: "3.6"
    }, {
        Processor: "E3-1290 ",
        cores: "1974",
        GHz: "3.2"
    }, {
        Processor: "E3-1286L v3 ",
        cores: "2268",
        GHz: "3.7"
    }, {
        Processor: "E3-1286 v3 ",
        cores: "2248",
        GHz: "3.4"
    }, {
        Processor: "E3-1285L v4 ",
        cores: "2209",
        GHz: "3.1"
    }, {
        Processor: "E3-1285L v3 ",
        cores: "2263",
        GHz: "4.1"
    }, {
        Processor: "E3-1285 v6 ",
        cores: "2486",
        GHz: "3.5"
    }, {
        Processor: "E3-1285 v4 ",
        cores: "2090",
        GHz: "3.6"
    }, {
        Processor: "E3-1285 v3 ",
        cores: "2306",
        GHz: "3.7"
    }, {
        Processor: "E3-1281 v3 ",
        cores: "2353",
        GHz: "3.9"
    }, {
        Processor: "E3-1280 v6 ",
        cores: "2428",
        GHz: "3.7"
    }, {
        Processor: "E3-1280 v5 ",
        cores: "2257",
        GHz: "3.6"
    }, {
        Processor: "E3-1280 v3 ",
        cores: "2251",
        GHz: "3.6"
    }, {
        Processor: "E3-1280 V2 ",
        cores: "2090",
        GHz: "3.5"
    }, {
        Processor: "E3-1280 ",
        cores: "1965",
        GHz: "3.6"
    }, {
        Processor: "E3-1276 v3 ",
        cores: "2290",
        GHz: "2.7"
    }, {
        Processor: "E3-1275L v3 ",
        cores: "2167",
        GHz: "3.8"
    }, {
        Processor: "E3-1275 v6 ",
        cores: "2358",
        GHz: "3.6"
    }, {
        Processor: "E3-1275 v5 ",
        cores: "2177",
        GHz: "3.5"
    }, {
        Processor: "E3-1275 v3 ",
        cores: "2214",
        GHz: "3.5"
    }, {
        Processor: "E3-1275 V2 ",
        cores: "2081",
        GHz: "3.4"
    }, {
        Processor: "E3-1275 ",
        cores: "1928",
        GHz: "3.6"
    }, {
        Processor: "E3-1271 v3 ",
        cores: "2271",
        GHz: "3"
    }, {
        Processor: "E3-1270L v4 ",
        cores: "2204",
        GHz: "3.8"
    }, {
        Processor: "E3-1270 v6 ",
        cores: "2308",
        GHz: "3.6"
    }, {
        Processor: "E3-1270 v5 ",
        cores: "2171",
        GHz: "3.5"
    }, {
        Processor: "E3-1270 v3 ",
        cores: "2228",
        GHz: "3.5"
    }, {
        Processor: "E3-1270 V2 ",
        cores: "2083",
        GHz: "3.4"
    }, {
        Processor: "E3-1270 ",
        cores: "1917",
        GHz: "2.3"
    }, {
        Processor: "E3-1268L v3 ",
        cores: "1949",
        GHz: "2.3"
    }, {
        Processor: "E3-1265L v4 ",
        cores: "1832",
        GHz: "2.5"
    }, {
        Processor: "E3-1265L v3 ",
        cores: "2140",
        GHz: "2.9"
    }, {
        Processor: "E3-1260L v5 ",
        cores: "2163",
        GHz: "3.5"
    }, {
        Processor: "E3-1246 v3 ",
        cores: "2240",
        GHz: "3.7"
    }, {
        Processor: "E3-1245 v6 ",
        cores: "2282",
        GHz: "3.5"
    }, {
        Processor: "E3-1245 v5 ",
        cores: "2137",
        GHz: "3.4"
    }, {
        Processor: "E3-1245 v3 ",
        cores: "2174",
        GHz: "3.4"
    }, {
        Processor: "E3-1245 V2 ",
        cores: "2007",
        GHz: "3.3"
    }, {
        Processor: "E3-1245 ",
        cores: "1853",
        GHz: "3.5"
    }, {
        Processor: "E3-1241 v3 ",
        cores: "2255",
        GHz: "3.7"
    }, {
        Processor: "E3-1240 v6 ",
        cores: "2206",
        GHz: "3.5"
    }, {
        Processor: "E3-1240 v5 ",
        cores: "2209",
        GHz: "3.4"
    }, {
        Processor: "E3-1240 v3 ",
        cores: "2180",
        GHz: "3.4"
    }, {
        Processor: "E3-1240 V2 ",
        cores: "2028",
        GHz: "3.3"
    }, {
        Processor: "E3-1240 ",
        cores: "1831",
        GHz: "3.2"
    }, {
        Processor: "E3-1235 ",
        cores: "1832",
        GHz: "3.4"
    }, {
        Processor: "E3-1231 v3 ",
        cores: "2168",
        GHz: "3.5"
    }, {
        Processor: "E3-1230 v6 ",
        cores: "2005",
        GHz: "3.4"
    }, {
        Processor: "E3-1230 v5 ",
        cores: "2069",
        GHz: "3.3"
    }, {
        Processor: "E3-1230 v3 ",
        cores: "2094",
        GHz: "3.3"
    }, {
        Processor: "E3-1230 V2 ",
        cores: "1946",
        GHz: "3.2"
    }, {
        Processor: "E3-1230 ",
        cores: "1810",
        GHz: "3.3"
    }, {
        Processor: "E3-1226 v3 ",
        cores: "2095",
        GHz: "3.3"
    }, {
        Processor: "E3-1225 v6 ",
        cores: "2151",
        GHz: "3.3"
    }, {
        Processor: "E3-1225 v5 ",
        cores: "1964",
        GHz: "3.2"
    }, {
        Processor: "E3-1225 v3 ",
        cores: "2013",
        GHz: "3.2"
    }, {
        Processor: "E3-1225 V2 ",
        cores: "1915",
        GHz: "3"
    }, {
        Processor: "E3-1220 v5 ",
        cores: "1950",
        GHz: "3.1"
    }, {
        Processor: "E3-1220 v3 ",
        cores: "1946",
        GHz: "3.1"
    }, {
        Processor: "E3-1220 V2 ",
        cores: "1828",
        GHz: "2.4"
    }, {
        Processor: "E-2286M ",
        cores: "2447",
        GHz: "2.8"
    }, {
        Processor: "E-2276M ",
        cores: "2757",
        GHz: "3.5"
    }, {
        Processor: "E-2224G ",
        cores: "2813",
        GHz: "3.4"
    }, {
        Processor: "E-2224 ",
        cores: "2711",
        GHz: "2.9"
    }, {
        Processor: "E-2186M ",
        cores: "2603",
        GHz: "3.8"
    }, {
        Processor: "E-2186G ",
        cores: "2744",
        GHz: "2.7"
    }, {
        Processor: "E-2176M ",
        cores: "2503",
        GHz: "3.7"
    }, {
        Processor: "E-2176G ",
        cores: "2706",
        GHz: "3.8"
    }, {
        Processor: "E-2174G ",
        cores: "2663",
        GHz: "3.5"
    }, {
        Processor: "E-2146G ",
        cores: "2603",
        GHz: "3.6"
    }, {
        Processor: "E-2144G ",
        cores: "2621",
        GHz: "3.3"
    }, {
        Processor: "E-2136 ",
        cores: "2643",
        GHz: "3.5"
    }, {
        Processor: "E-2134 ",
        cores: "2571",
        GHz: "3.3"
    }, {
        Processor: "E-2126G ",
        cores: "2627",
        GHz: "3.4"
    }, {
        Processor: "E-2124G ",
        cores: "2578",
        GHz: "3.3"
    }, {
        Processor: "E-2124 ",
        cores: "2488",
        GHz: "3.2"
    }, {
        Processor: "E-2104G ",
        cores: "1927",
        GHz: "3"
    }],
  },
  {
    renderKey: "Intel Core",
    renderValue: [{
        Processor: "i9-9980XE ",
        cores: "2456",
        GHz: "2.4"
    }, {
        Processor: "i9-9980HK ",
        cores: "2623",
        GHz: "3.1"
    }, {
        Processor: "i9-9960X ",
        cores: "2460",
        GHz: "3.3"
    }, {
        Processor: "i9-9940X ",
        cores: "2464",
        GHz: "3.5"
    }, {
        Processor: "i9-9920X ",
        cores: "2523",
        GHz: "3.5"
    }, {
        Processor: "i9-9900X ",
        cores: "2492",
        GHz: "3.6"
    }, {
        Processor: "i9-9900KF ",
        cores: "2938",
        GHz: "3.6"
    }, {
        Processor: "i9-9900K ",
        cores: "2898",
        GHz: "3.1"
    }, {
        Processor: "i9-9900 ",
        cores: "2884",
        GHz: "2.3"
    }, {
        Processor: "i9-9880H ",
        cores: "2569",
        GHz: "3.3"
    }, {
        Processor: "i9-9820X ",
        cores: "2350",
        GHz: "2.9"
    }, {
        Processor: "i9-8950HK ",
        cores: "2549",
        GHz: "2.6"
    }, {
        Processor: "i9-7980XE ",
        cores: "2347",
        GHz: "2.8"
    }, {
        Processor: "i9-7960X ",
        cores: "2335",
        GHz: "3.1"
    }, {
        Processor: "i9-7940X ",
        cores: "2398",
        GHz: "2.9"
    }, {
        Processor: "i9-7920X ",
        cores: "2399",
        GHz: "3.3"
    }, {
        Processor: "i9-7900X ",
        cores: "2454",
        GHz: "2.6"
    }, {
        Processor: "i7-9850H ",
        cores: "2618",
        GHz: "3.8"
    }, {
        Processor: "i7-9800X ",
        cores: "2526",
        GHz: "2.6"
    }, {
        Processor: "i7-9750H ",
        cores: "2498",
        GHz: "2"
    }, {
        Processor: "i7-9700T ",
        cores: "2568",
        GHz: "3.6"
    }, {
        Processor: "i7-9700KF ",
        cores: "2811",
        GHz: "3.6"
    }, {
        Processor: "i7-9700K ",
        cores: "2819",
        GHz: "3"
    }, {
        Processor: "i7-9700F ",
        cores: "2706",
        GHz: "3"
    }, {
        Processor: "i7-9700 ",
        cores: "2709",
        GHz: "2.6"
    }, {
        Processor: "i7-8850H ",
        cores: "2457",
        GHz: "3.1"
    }, {
        Processor: "i7-8809G ",
        cores: "2340",
        GHz: "2.2"
    }, {
        Processor: "i7-8750H ",
        cores: "2353",
        GHz: "3.1"
    }, {
        Processor: "i7-8709G ",
        cores: "2178",
        GHz: "3.1"
    }, {
        Processor: "i7-8706G ",
        cores: "2347",
        GHz: "3.1"
    }, {
        Processor: "i7-8705G ",
        cores: "2216",
        GHz: "2.4"
    }, {
        Processor: "i7-8700T ",
        cores: "2348",
        GHz: "3.7"
    }, {
        Processor: "i7-8700K ",
        cores: "2701",
        GHz: "3.2"
    }, {
        Processor: "i7-8700B ",
        cores: "2664",
        GHz: "3.2"
    }, {
        Processor: "i7-8700 ",
        cores: "2630",
        GHz: "1.9"
    }, {
        Processor: "i7-8665U ",
        cores: "2410",
        GHz: "1.9"
    }, {
        Processor: "i7-8650U ",
        cores: "2245",
        GHz: "1.8"
    }, {
        Processor: "i7-8565U ",
        cores: "2349",
        GHz: "2.7"
    }, {
        Processor: "i7-8559U ",
        cores: "2609",
        GHz: "1.8"
    }, {
        Processor: "i7-8550U ",
        cores: "2138",
        GHz: "4"
    }, {
        Processor: "i7-8086K ",
        cores: "2833",
        GHz: "3.1"
    }, {
        Processor: "i7-7920HQ ",
        cores: "2110",
        GHz: "3.3"
    }, {
        Processor: "i7-7900X ",
        cores: "2463",
        GHz: "3.6"
    }, {
        Processor: "i7-7820X ",
        cores: "2399",
        GHz: "2.9"
    }, {
        Processor: "i7-7820HQ ",
        cores: "2044",
        GHz: "2.9"
    }, {
        Processor: "i7-7820HK ",
        cores: "2076",
        GHz: "3.5"
    }, {
        Processor: "i7-7800X ",
        cores: "2259",
        GHz: "4.3"
    }, {
        Processor: "i7-7740X ",
        cores: "2626",
        GHz: "2.9"
    }, {
        Processor: "i7-7700T ",
        cores: "2042",
        GHz: "4.2"
    }, {
        Processor: "i7-7700K ",
        cores: "2583",
        GHz: "2.8"
    }, {
        Processor: "i7-7700HQ ",
        cores: "1995",
        GHz: "3.6"
    }, {
        Processor: "i7-7700 ",
        cores: "2346",
        GHz: "2.5"
    }, {
        Processor: "i7-7660U ",
        cores: "2162",
        GHz: "2.8"
    }, {
        Processor: "i7-7600U ",
        cores: "1965",
        GHz: "3.5"
    }, {
        Processor: "i7-7567U ",
        cores: "2263",
        GHz: "2.4"
    }, {
        Processor: "i7-7560U ",
        cores: "2095",
        GHz: "2.7"
    }, {
        Processor: "i7-7500U ",
        cores: "1914",
        GHz: "3"
    }, {
        Processor: "i7-6950X ",
        cores: "2148",
        GHz: "2.9"
    }, {
        Processor: "i7-6920HQ ",
        cores: "2013",
        GHz: "3.2"
    }, {
        Processor: "i7-6900K ",
        cores: "2187",
        GHz: "3.6"
    }, {
        Processor: "i7-6850K ",
        cores: "2192",
        GHz: "2.7"
    }, {
        Processor: "i7-6820HQ ",
        cores: "1879",
        GHz: "2.7"
    }, {
        Processor: "i7-6820HK ",
        cores: "1884",
        GHz: "2.8"
    }, {
        Processor: "i7-6820EQ ",
        cores: "1925",
        GHz: "3.4"
    }, {
        Processor: "i7-6800K ",
        cores: "2064",
        GHz: "2.6"
    }, {
        Processor: "i7-6770HQ ",
        cores: "1909",
        GHz: "2.4"
    }, {
        Processor: "i7-6700TE ",
        cores: "1923",
        GHz: "2.8"
    }, {
        Processor: "i7-6700T ",
        cores: "1979",
        GHz: "4"
    }, {
        Processor: "i7-6700K ",
        cores: "2354",
        GHz: "3.4"
    }, {
        Processor: "i7-6700 ",
        cores: "2154",
        GHz: "2.2"
    }, {
        Processor: "i7-6650U ",
        cores: "1812",
        GHz: "2.6"
    }, {
        Processor: "i7-6600U ",
        cores: "1805",
        GHz: "3.3"
    }, {
        Processor: "i7-6567U ",
        cores: "2006",
        GHz: "3"
    }, {
        Processor: "i7-5960X ",
        cores: "1997",
        GHz: "2.9"
    }, {
        Processor: "i7-5950HQ ",
        cores: "2238",
        GHz: "3.5"
    }, {
        Processor: "i7-5930K ",
        cores: "2100",
        GHz: "2.7"
    }, {
        Processor: "i7-5850HQ ",
        cores: "2077",
        GHz: "2.7"
    }, {
        Processor: "i7-5850EQ ",
        cores: "1964",
        GHz: "3.3"
    }, {
        Processor: "i7-5820K ",
        cores: "2022",
        GHz: "3.3"
    }, {
        Processor: "i7-5775R ",
        cores: "2144",
        GHz: "3.3"
    }, {
        Processor: "i7-5775C ",
        cores: "2225",
        GHz: "2.7"
    }, {
        Processor: "i7-5700HQ ",
        cores: "1996",
        GHz: "2.6"
    }, {
        Processor: "i7-5700EQ ",
        cores: "1969",
        GHz: "3.1"
    }, {
        Processor: "i7-5675C ",
        cores: "2197",
        GHz: "3.1"
    }, {
        Processor: "i7-5557U ",
        cores: "1893",
        GHz: "2.8"
    }, {
        Processor: "i7-4980HQ ",
        cores: "2256",
        GHz: "3.6"
    }, {
        Processor: "i7-4960X ",
        cores: "2080",
        GHz: "2.6"
    }, {
        Processor: "i7-4960HQ ",
        cores: "2166",
        GHz: "3.1"
    }, {
        Processor: "i7-4940MX ",
        cores: "2261",
        GHz: "3"
    }, {
        Processor: "i7-4930MX ",
        cores: "2173",
        GHz: "3.4"
    }, {
        Processor: "i7-4930K ",
        cores: "1996",
        GHz: "2.9"
    }, {
        Processor: "i7-4910MQ ",
        cores: "2148",
        GHz: "2.8"
    }, {
        Processor: "i7-4900MQ ",
        cores: "2072",
        GHz: "2.5"
    }, {
        Processor: "i7-4870HQ ",
        cores: "2047",
        GHz: "2.4"
    }, {
        Processor: "i7-4860HQ ",
        cores: "1963",
        GHz: "2.3"
    }, {
        Processor: "i7-4850HQ ",
        cores: "1947",
        GHz: "3.7"
    }, {
        Processor: "i7-4820K ",
        cores: "2013",
        GHz: "2.8"
    }, {
        Processor: "i7-4810MQ ",
        cores: "2064",
        GHz: "2.7"
    }, {
        Processor: "i7-4800MQ ",
        cores: "1992",
        GHz: "2.7"
    }, {
        Processor: "i7-4790T ",
        cores: "2163",
        GHz: "3.2"
    }, {
        Processor: "i7-4790S ",
        cores: "2250",
        GHz: "4"
    }, {
        Processor: "i7-4790K ",
        cores: "2529",
        GHz: "3.6"
    }, {
        Processor: "i7-4790 ",
        cores: "2282",
        GHz: "3.5"
    }, {
        Processor: "i7-4771 ",
        cores: "2217",
        GHz: "2.5"
    }, {
        Processor: "i7-4770T ",
        cores: "2068",
        GHz: "3.1"
    }, {
        Processor: "i7-4770S ",
        cores: "2174",
        GHz: "3.2"
    }, {
        Processor: "i7-4770R ",
        cores: "2147",
        GHz: "3.5"
    }, {
        Processor: "i7-4770K ",
        cores: "2250",
        GHz: "2.2"
    }, {
        Processor: "i7-4770HQ ",
        cores: "1893",
        GHz: "3.4"
    }, {
        Processor: "i7-4770 ",
        cores: "2227",
        GHz: "2.1"
    }, {
        Processor: "i7-4760HQ ",
        cores: "1821",
        GHz: "2.4"
    }, {
        Processor: "i7-4722HQ ",
        cores: "1945",
        GHz: "2.6"
    }, {
        Processor: "i7-4720HQ ",
        cores: "1909",
        GHz: "2.5"
    }, {
        Processor: "i7-4710MQ ",
        cores: "1898",
        GHz: "2.5"
    }, {
        Processor: "i7-4710HQ ",
        cores: "1820",
        GHz: "2.4"
    }, {
        Processor: "i7-4700MQ ",
        cores: "1807",
        GHz: "2.4"
    }, {
        Processor: "i7-4700EQ ",
        cores: "1815",
        GHz: "3"
    }, {
        Processor: "i7-4610M ",
        cores: "1968",
        GHz: "2.9"
    }, {
        Processor: "i7-4600M ",
        cores: "1959",
        GHz: "3"
    }, {
        Processor: "i7-4578U ",
        cores: "1988",
        GHz: "1.6"
    }, {
        Processor: "i7-4560U ",
        cores: "1807",
        GHz: "3.5"
    }, {
        Processor: "i7-3970X ",
        cores: "2015",
        GHz: "3.3"
    }, {
        Processor: "i7-3960X ",
        cores: "1987",
        GHz: "3"
    }, {
        Processor: "i7-3940XM ",
        cores: "2003",
        GHz: "3.2"
    }, {
        Processor: "i7-3930K ",
        cores: "1935",
        GHz: "2.9"
    }, {
        Processor: "i7-3920XM ",
        cores: "2000",
        GHz: "2.8"
    }, {
        Processor: "i7-3840QM ",
        cores: "1914",
        GHz: "2.7"
    }, {
        Processor: "i7-3820QM ",
        cores: "1846",
        GHz: "3.6"
    }, {
        Processor: "i7-3820 ",
        cores: "1942",
        GHz: "2.5"
    }, {
        Processor: "i7-3770T ",
        cores: "1935",
        GHz: "3.1"
    }, {
        Processor: "i7-3770S ",
        cores: "2025",
        GHz: "3.5"
    }, {
        Processor: "i7-3770K ",
        cores: "2082",
        GHz: "3.4"
    }, {
        Processor: "i7-3770 ",
        cores: "2068",
        GHz: "2.7"
    }, {
        Processor: "i7-3740QM ",
        cores: "1873",
        GHz: "2.6"
    }, {
        Processor: "i7-3720QM ",
        cores: "1820",
        GHz: "3"
    }, {
        Processor: "i7-3540M ",
        cores: "1828",
        GHz: "3.5"
    }, {
        Processor: "i7-2700K ",
        cores: "2003",
        GHz: "2.8"
    }, {
        Processor: "i7-2600S ",
        cores: "1810",
        GHz: "3.4"
    }, {
        Processor: "i7-2600K ",
        cores: "1938",
        GHz: "3.4"
    }, {
        Processor: "i7-2600 ",
        cores: "1922",
        GHz: "3.7"
    }, {
        Processor: "i5-9600KF ",
        cores: "2753",
        GHz: "3.7"
    }, {
        Processor: "i5-9600K ",
        cores: "2681",
        GHz: "2.2"
    }, {
        Processor: "i5-9500T ",
        cores: "2230",
        GHz: "3"
    }, {
        Processor: "i5-9500 ",
        cores: "2620",
        GHz: "1.8"
    }, {
        Processor: "i5-9400T ",
        cores: "1990",
        GHz: "2.5"
    }, {
        Processor: "i5-9400H ",
        cores: "2512",
        GHz: "2.9"
    }, {
        Processor: "i5-9400F ",
        cores: "2393",
        GHz: "2.9"
    }, {
        Processor: "i5-9400 ",
        cores: "2390",
        GHz: "2.4"
    }, {
        Processor: "i5-9300H ",
        cores: "2359",
        GHz: "2.3"
    }, {
        Processor: "i5-8600T ",
        cores: "2209",
        GHz: "3.6"
    }, {
        Processor: "i5-8600K ",
        cores: "2514",
        GHz: "3.1"
    }, {
        Processor: "i5-8600 ",
        cores: "2506",
        GHz: "2.1"
    }, {
        Processor: "i5-8500T ",
        cores: "2038",
        GHz: "3"
    }, {
        Processor: "i5-8500B ",
        cores: "2466",
        GHz: "3"
    }, {
        Processor: "i5-8500 ",
        cores: "2409",
        GHz: "1.7"
    }, {
        Processor: "i5-8400T ",
        cores: "1928",
        GHz: "2.5"
    }, {
        Processor: "i5-8400H ",
        cores: "2461",
        GHz: "2.8"
    }, {
        Processor: "i5-8400 ",
        cores: "2337",
        GHz: "1.6"
    }, {
        Processor: "i5-8365U ",
        cores: "2299",
        GHz: "1.7"
    }, {
        Processor: "i5-8350U ",
        cores: "2083",
        GHz: "2.8"
    }, {
        Processor: "i5-8305G ",
        cores: "2084",
        GHz: "2.3"
    }, {
        Processor: "i5-8300H ",
        cores: "2297",
        GHz: "1.6"
    }, {
        Processor: "i5-8265UC ",
        cores: "2144",
        GHz: "1.6"
    }, {
        Processor: "i5-8265U ",
        cores: "2131",
        GHz: "2.3"
    }, {
        Processor: "i5-8259U ",
        cores: "2224",
        GHz: "1.6"
    }, {
        Processor: "i5-8250U ",
        cores: "1937",
        GHz: "4"
    }, {
        Processor: "i5-7640X ",
        cores: "2460",
        GHz: "2.8"
    }, {
        Processor: "i5-7600T ",
        cores: "2113",
        GHz: "3.8"
    }, {
        Processor: "i5-7600K ",
        cores: "2383",
        GHz: "3.5"
    }, {
        Processor: "i5-7600 ",
        cores: "2284",
        GHz: "2.7"
    }, {
        Processor: "i5-7500T ",
        cores: "1862",
        GHz: "3.4"
    }, {
        Processor: "i5-7500 ",
        cores: "2115",
        GHz: "2.8"
    }, {
        Processor: "i5-7440HQ ",
        cores: "2095",
        GHz: "3"
    }, {
        Processor: "i5-7400 ",
        cores: "1948",
        GHz: "2.3"
    }, {
        Processor: "i5-7360U ",
        cores: "2055",
        GHz: "2.6"
    }, {
        Processor: "i5-7300U ",
        cores: "1963",
        GHz: "2.5"
    }, {
        Processor: "i5-7300HQ ",
        cores: "1863",
        GHz: "3.3"
    }, {
        Processor: "i5-7287U ",
        cores: "1932",
        GHz: "2.2"
    }, {
        Processor: "i5-7260U ",
        cores: "1949",
        GHz: "2.7"
    }, {
        Processor: "i5-6600T ",
        cores: "1927",
        GHz: "3.5"
    }, {
        Processor: "i5-6600K ",
        cores: "2147",
        GHz: "3.3"
    }, {
        Processor: "i5-6600 ",
        cores: "2095",
        GHz: "3.2"
    }, {
        Processor: "i5-6500 ",
        cores: "1947",
        GHz: "2.6"
    }, {
        Processor: "i5-6440HQ ",
        cores: "1876",
        GHz: "2.7"
    }, {
        Processor: "i5-6440EQ ",
        cores: "1845",
        GHz: "2.8"
    }, {
        Processor: "i5-6402P ",
        cores: "1902",
        GHz: "2.7"
    }, {
        Processor: "i5-6400 ",
        cores: "1825",
        GHz: "3.1"
    }, {
        Processor: "i5-5675R ",
        cores: "2063",
        GHz: "3.1"
    }, {
        Processor: "i5-5675C ",
        cores: "2141",
        GHz: "2.8"
    }, {
        Processor: "i5-5575R ",
        cores: "1888",
        GHz: "2.9"
    }, {
        Processor: "i5-5287U ",
        cores: "1840",
        GHz: "2.5"
    }, {
        Processor: "i5-4690T ",
        cores: "1959",
        GHz: "3.2"
    }, {
        Processor: "i5-4690S ",
        cores: "2194",
        GHz: "3.5"
    }, {
        Processor: "i5-4690K ",
        cores: "2235",
        GHz: "3.5"
    }, {
        Processor: "i5-4690 ",
        cores: "2217",
        GHz: "2.3"
    }, {
        Processor: "i5-4670T ",
        cores: "1836",
        GHz: "3.1"
    }, {
        Processor: "i5-4670S ",
        cores: "2144",
        GHz: "3"
    }, {
        Processor: "i5-4670R ",
        cores: "2160",
        GHz: "3.4"
    }, {
        Processor: "i5-4670K CPT ",
        cores: "2099",
        GHz: "3.4"
    }, {
        Processor: "i5-4670K ",
        cores: "2188",
        GHz: "3.4"
    }, {
        Processor: "i5-4670 ",
        cores: "2156",
        GHz: "3"
    }, {
        Processor: "i5-4590S ",
        cores: "2099",
        GHz: "3.3"
    }, {
        Processor: "i5-4590 ",
        cores: "2115",
        GHz: "2.9"
    }, {
        Processor: "i5-4570T ",
        cores: "1985",
        GHz: "2.9"
    }, {
        Processor: "i5-4570S ",
        cores: "2003",
        GHz: "2.7"
    }, {
        Processor: "i5-4570R ",
        cores: "1865",
        GHz: "3.2"
    }, {
        Processor: "i5-4570 ",
        cores: "2056",
        GHz: "2.9"
    }, {
        Processor: "i5-4460S ",
        cores: "1915",
        GHz: "3.2"
    }, {
        Processor: "i5-4460 ",
        cores: "1942",
        GHz: "2.8"
    }, {
        Processor: "i5-4440S ",
        cores: "1860",
        GHz: "3.1"
    }, {
        Processor: "i5-4440 ",
        cores: "1879",
        GHz: "3"
    }, {
        Processor: "i5-4430 ",
        cores: "1826",
        GHz: "2.7"
    }, {
        Processor: "i5-4400E ",
        cores: "1899",
        GHz: "2.9"
    }, {
        Processor: "i5-4340M ",
        cores: "1967",
        GHz: "2.8"
    }, {
        Processor: "i5-4330M ",
        cores: "1836",
        GHz: "2.7"
    }, {
        Processor: "i5-4310M ",
        cores: "1891",
        GHz: "2.9"
    }, {
        Processor: "i5-4210H ",
        cores: "1877",
        GHz: "2.8"
    }, {
        Processor: "i5-4200H ",
        cores: "1834",
        GHz: "3.1"
    }, {
        Processor: "i5-3570S ",
        cores: "1965",
        GHz: "3.4"
    }, {
        Processor: "i5-3570K ",
        cores: "2028",
        GHz: "3.4"
    }, {
        Processor: "i5-3570 ",
        cores: "2022",
        GHz: "3"
    }, {
        Processor: "i5-3550S ",
        cores: "1979",
        GHz: "3.3"
    }, {
        Processor: "i5-3550 ",
        cores: "1970",
        GHz: "2.9"
    }, {
        Processor: "i5-3475S ",
        cores: "1895",
        GHz: "2.9"
    }, {
        Processor: "i5-3470T ",
        cores: "1832",
        GHz: "2.9"
    }, {
        Processor: "i5-3470S ",
        cores: "1861",
        GHz: "3.2"
    }, {
        Processor: "i5-3470 ",
        cores: "1915",
        GHz: "2.8"
    }, {
        Processor: "i5-3450S ",
        cores: "1812",
        GHz: "3.1"
    }, {
        Processor: "i5-3450 ",
        cores: "1857",
        GHz: "3.4"
    }, {
        Processor: "i5-2550K ",
        cores: "1937",
        GHz: "2.7"
    }, {
        Processor: "i5-2500S ",
        cores: "1810",
        GHz: "3.3"
    }, {
        Processor: "i5-2500K ",
        cores: "1896",
        GHz: "3.3"
    }, {
        Processor: "i5-2500 ",
        cores: "1877",
        GHz: "4"
    }, {
        Processor: "i3-9350KF ",
        cores: "2563",
        GHz: "3.2"
    }, {
        Processor: "i3-9300T ",
        cores: "2234",
        GHz: "3.7"
    }, {
        Processor: "i3-9300 ",
        cores: "2530",
        GHz: "3.1"
    }, {
        Processor: "i3-9100T ",
        cores: "2167",
        GHz: "3.6"
    }, {
        Processor: "i3-9100F ",
        cores: "2431",
        GHz: "3.6"
    }, {
        Processor: "i3-9100 ",
        cores: "2410",
        GHz: "4"
    }, {
        Processor: "i3-8350K ",
        cores: "2336",
        GHz: "3.2"
    }, {
        Processor: "i3-8300T ",
        cores: "1888",
        GHz: "3.7"
    }, {
        Processor: "i3-8300 ",
        cores: "2168",
        GHz: "2.1"
    }, {
        Processor: "i3-8145U ",
        cores: "2164",
        GHz: "2.2"
    }, {
        Processor: "i3-8130U ",
        cores: "1938",
        GHz: "3"
    }, {
        Processor: "i3-8109U ",
        cores: "2162",
        GHz: "3.1"
    }, {
        Processor: "i3-8100T ",
        cores: "1826",
        GHz: "3.6"
    }, {
        Processor: "i3-8100B ",
        cores: "2173",
        GHz: "3.6"
    }, {
        Processor: "i3-8100 ",
        cores: "2100",
        GHz: "4.2"
    }, {
        Processor: "i3-7350K ",
        cores: "2428",
        GHz: "4.1"
    }, {
        Processor: "i3-7320 ",
        cores: "2346",
        GHz: "3.5"
    }, {
        Processor: "i3-7300T ",
        cores: "1928",
        GHz: "4"
    }, {
        Processor: "i3-7300 ",
        cores: "2308",
        GHz: "3.4"
    }, {
        Processor: "i3-7101TE ",
        cores: "1963",
        GHz: "3.4"
    }, {
        Processor: "i3-7100T ",
        cores: "1917",
        GHz: "3.9"
    }, {
        Processor: "i3-7100 ",
        cores: "2227",
        GHz: "3.9"
    }, {
        Processor: "i3-6320 ",
        cores: "2237",
        GHz: "3.3"
    }, {
        Processor: "i3-6300T ",
        cores: "1902",
        GHz: "3.8"
    }, {
        Processor: "i3-6300 ",
        cores: "2165",
        GHz: "3.2"
    }, {
        Processor: "i3-6100T ",
        cores: "1820",
        GHz: "3.7"
    }, {
        Processor: "i3-6100 ",
        cores: "2106",
        GHz: "3.6"
    }, {
        Processor: "i3-6098P ",
        cores: "2081",
        GHz: "2.9"
    }, {
        Processor: "i3-4570T ",
        cores: "1931",
        GHz: "3.3"
    }, {
        Processor: "i3-4370T ",
        cores: "1943",
        GHz: "3.8"
    }, {
        Processor: "i3-4370 ",
        cores: "2219",
        GHz: "3.2"
    }, {
        Processor: "i3-4360T ",
        cores: "1894",
        GHz: "3.7"
    }, {
        Processor: "i3-4360 ",
        cores: "2149",
        GHz: "3.1"
    }, {
        Processor: "i3-4350T ",
        cores: "1810",
        GHz: "3.6"
    }, {
        Processor: "i3-4350 ",
        cores: "2097",
        GHz: "3.6"
    }, {
        Processor: "i3-4340 ",
        cores: "2086",
        GHz: "3.5"
    }, {
        Processor: "i3-4330 ",
        cores: "2029",
        GHz: "3.2"
    }, {
        Processor: "i3-4170T ",
        cores: "1831",
        GHz: "3.7"
    }, {
        Processor: "i3-4170 ",
        cores: "2129",
        GHz: "3.1"
    }, {
        Processor: "i3-4160T ",
        cores: "1802",
        GHz: "3.6"
    }, {
        Processor: "i3-4160 ",
        cores: "2073",
        GHz: "3.5"
    }, {
        Processor: "i3-4150 ",
        cores: "2009",
        GHz: "3.4"
    }, {
        Processor: "i3-4130 ",
        cores: "1962",
        GHz: "3.5"
    }, {
        Processor: "i3-3250 ",
        cores: "1850",
        GHz: "3.4"
    }, {
        Processor: "i3-3245 ",
        cores: "1829",
        GHz: "3.4"
    }]
  }
];
export const gpuDate = [{
  graphicsCard: "GeForce GTX 1050",
  cores: "2827"
}, {
    graphicsCard: "GeForce GTX 1050 Ti",
    cores: "3235"
}, {
    graphicsCard: "GeForce GTX 1060",
    cores: "4991"
}, {
    graphicsCard: "GeForce GTX 1060 3GB",
    cores: "4635"
}, {
    graphicsCard: "GeForce GTX 1070",
    cores: "6543"
}, {
    graphicsCard: "GeForce GTX 1070 Ti",
    cores: "7356"
}, {
    graphicsCard: "GeForce GTX 1080",
    cores: "7862"
}, {
    graphicsCard: "GeForce GTX 1080 Ti",
    cores: "9347"
}, {
    graphicsCard: "GeForce GTX 1650",
    cores: "3787"
}, {
    graphicsCard: "GeForce GTX 1660",
    cores: "4972"
}, {
    graphicsCard: "GeForce GTX 1660 Ti",
    cores: "5259"
}, {
    graphicsCard: "GeForce GTX 660 Ti",
    cores: "2575"
}, {
    graphicsCard: "GeForce GTX 670",
    cores: "2620"
}, {
    graphicsCard: "GeForce GTX 680",
    cores: "2969"
}, {
    graphicsCard: "GeForce GTX 690",
    cores: "2523"
}, {
    graphicsCard: "GeForce GTX 760 Ti",
    cores: "2693"
}, {
    graphicsCard: "GeForce GTX 770",
    cores: "3142"
}, {
    graphicsCard: "GeForce GTX 780",
    cores: "3983"
}, {
    graphicsCard: "GeForce GTX 780 Ti",
    cores: "4699"
}, {
    graphicsCard: "GeForce GTX 950",
    cores: "2544"
}, {
    graphicsCard: "GeForce GTX 960",
    cores: "3106"
}, {
    graphicsCard: "GeForce GTX 970",
    cores: "4420"
}, {
    graphicsCard: "GeForce GTX 970M",
    cores: "2811"
}, {
    graphicsCard: "GeForce GTX 980",
    cores: "5157"
}, {
    graphicsCard: "GeForce GTX 980 Ti",
    cores: "6357"
}, {
    graphicsCard: "GeForce GTX Titan",
    cores: "4138"
}, {
    graphicsCard: "GeForce GTX TITAN X",
    cores: "6203"
}, {
    graphicsCard: "GeForce GTX TITAN Z",
    cores: "3418"
}, {
    graphicsCard: "GeForce RTX 2060",
    cores: "5995"
}, {
    graphicsCard: "GeForce RTX 2070",
    cores: "6577"
}, {
    graphicsCard: "GeForce RTX 2080",
    cores: "7467"
}, {
    graphicsCard: "GeForce RTX 2080 Ti",
    cores: "8836"
}, {
    graphicsCard: "NVIDIA TITAN X",
    cores: "9219"
}, {
    graphicsCard: "NVIDIA TITAN Xp",
    cores: "9103"
}, {
    graphicsCard: "Quadro K5200",
    cores: "2860"
}, {
    graphicsCard: "Quadro K6000",
    cores: "3953"
}, {
    graphicsCard: "Quadro M4000",
    cores: "2748"
}, {
    graphicsCard: "Quadro M5000",
    cores: "4199"
}, {
    graphicsCard: "Quadro M6000",
    cores: "5363"
}, {
    graphicsCard: "Quadro P1000",
    cores: "2525"
}, {
    graphicsCard: "Quadro P2000",
    cores: "3695"
}, {
    graphicsCard: "Quadro P4000",
    cores: "5344"
}, {
    graphicsCard: "Quadro P5000",
    cores: "6555"
}, {
    graphicsCard: "Quadro P6000",
    cores: "8539"
}, {
    graphicsCard: "Quadro RTX 6000",
    cores: "8920"
}, {
    graphicsCard: "Radeon HD 7950 / R9 280",
    cores: "2725"
}, {
    graphicsCard: "Radeon HD 7990",
    cores: "2936"
}, {
    graphicsCard: "Radeon Pro Duo",
    cores: "5221"
}, {
    graphicsCard: "Radeon Pro WX 4100",
    cores: "2528"
}, {
  graphicsCard: "Radeon Pro WX 5100",
  cores: "2905"
}, {
  graphicsCard: "Radeon Pro WX 7100",
  cores: "4070"
}, {
  graphicsCard: "Radeon PRO WX 8200",
  cores: "6246"
}, {
  graphicsCard: "Radeon R9 270X",
  cores: "2587"
}, {
  graphicsCard: "Radeon R9 290 / 390",
  cores: "3325"
}, {
  graphicsCard: "Radeon R9 295X2",
  cores: "3576"
}, {
  graphicsCard: "Radeon R9 380",
  cores: "3004"
}, {
  graphicsCard: "Radeon R9 380X",
  cores: "3119"
}, {
  graphicsCard: "Radeon R9 Fury",
  cores: "5067"
}, {
  graphicsCard: "Radeon RX 470",
  cores: "3871"
}, {
  graphicsCard: "Radeon RX 480",
  cores: "4393"
}, {
  graphicsCard: "Radeon RX 570",
  cores: "3325"
}, {
  graphicsCard: "Radeon RX 5700",
  cores: "7175"
}, {
  graphicsCard: "Radeon RX 5700 XT",
  cores: "8239"
}, {
  graphicsCard: "Radeon RX 580",
  cores: "4361"
}, {
  graphicsCard: "Radeon RX 590",
  cores: "4905"
}, {
  graphicsCard: "Radeon RX Vega 56",
  cores: "6493"
}, {
  graphicsCard: "Radeon RX Vega 64",
  cores: "6995"
}, {
  graphicsCard: "TITAN RTX",
  cores: "8441"
}, {
  graphicsCard: "TITAN V",
  cores: "8956"
}, {
  graphicsCard: "TITAN V CEO Edition",
  cores: "10570"
}]
